import React from 'react'
import { Route } from 'react-router-dom'
import { Switch } from 'react-router-dom'
import { CustomizedSnackbar } from '../../../containers'
import { User } from '.'
import { MenuAppBar } from '../../../Parts/MenuAppBar'
import { LANGUAGE_SHORT_CODE } from '../../../constants';

class UserRouting extends React.Component {
  render() {
    var regstr = Object.keys(LANGUAGE_SHORT_CODE).map(key => LANGUAGE_SHORT_CODE[key]).join('|')
    return (
      <React.Fragment>
        <MenuAppBar/>
        <Switch>
          <Route path={`/:language(${regstr})/user/:userName/:tabName`} component={User} />
          <Route path={`/:language(${regstr})/user/:userName`} component={User} />
          <Route path='/user/:userName/:tabName' component={User} />
          <Route path='/user/:userName' component={User} />
        </Switch>
        <CustomizedSnackbar/>
      </React.Fragment>
    )
  }
}

export default (UserRouting)



// WEBPACK FOOTER //
// ./src/Pages/User/containers/UserRouting.js